import React from 'react';

import { Container } from '@adobe/cq-react-editable-components';
import { Row, Col, Grid } from '../../common/Grid';
import Button from '../../common/Button';
import AddressField from './Components/AddressField';
import { ConstantText, setSelectedAddress } from './constant';
import { store } from '../../../configureStore';
import { isMobile } from '../../common/Helpers';
import { apiUrls } from '../../../constants/apiUrl';
import { eventDispatcher } from '../../common/Tagging';

export default class AddressSearchComponent extends Container {
  constructor(props) {
    super(props);
    this.state = {
      fullAddress: this.props?.streetAddress,
      inputError: {
        value: false,
        errorText: null,
      },
    };
  }

  handleContinueButtonClick = (e) => {
    e.preventDefault();
    const { parsedAddress, makeRetriveZipcodeCall } = this.props;
    if (parsedAddress) {
      setSelectedAddress(parsedAddress);
    }
    if (parsedAddress?.zip) {
      eventDispatcher('sendData', {
        name: '',
        events: 'event354',
      });
      makeRetriveZipcodeCall({ data: { zipCode: parsedAddress?.zip } });
    }
  };

  onChangeTextBox = (id, e) => {
    const { value } = e?.target;
    const { updateUserTypedAddress, fetchAutoFillAddress, continueButtonStatus, onChangeStreetAddress } = this.props;
    if (id === 'addressLine1') {
      onChangeStreetAddress(value);
      continueButtonStatus(false);
      updateUserTypedAddress(value);
      if (value && value?.length > 0) {
        fetchAutoFillAddress(value);
      } else {
        store.dispatch({ type: 'FETCH_AUTOFILL_ADDRESS_SUCCESS', apiResponse: {} });
      }
    }
  };

  onAddressSelection = (e, addressSelected) => {
    const { storeUserSelectedAddress, updateParsedAddress, continueButtonStatus, onChangeStreetAddress } = this.props;
    storeUserSelectedAddress(e);
    onChangeStreetAddress(addressSelected?.[0]?.disprawstr || '');
    continueButtonStatus(true);
    updateParsedAddress(addressSelected && addressSelected?.[0]);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      retrieveZipCodeDetails,
      showErrorBanner,
      open,
      closebuttonFn,
      updateUserTypedAddress,
      continueButtonStatus,
      enableContinueButton,
      resetErrorMessage,
      parsedAddress,
      apiIntegration,
    } = this.props;
    if (nextProps?.retrieveZipCodeDetails !== retrieveZipCodeDetails) {
      if (
        nextProps?.retrieveZipCodeDetails?.details &&
        nextProps?.retrieveZipCodeDetails?.error?.value === false &&
        nextProps?.retrieveZipCodeDetails?.details?.marketDetails !== retrieveZipCodeDetails?.details?.marketDetails
      ) {
        if (open !== 'popup') {
          window.location.href = apiUrls().broadBandFacts;
        } else if (open === 'popup') {
          apiIntegration();
          closebuttonFn();
        }
        if (nextProps?.errorMessage?.value) {
          resetErrorMessage();
        }
        updateUserTypedAddress('');
        if (parsedAddress) {
          setSelectedAddress(parsedAddress);
        }
      } else if (nextProps?.retrieveZipCodeDetails?.error?.value !== this.props?.retrieveZipCodeDetails?.error?.value) {
        let error = { ...this.state?.inputError };
        let buttonEnable = enableContinueButton;
        if (nextProps?.retrieveZipCodeDetails?.error?.value) {
          buttonEnable = false;
          if (
            nextProps?.retrieveZipCodeDetails?.error?.errorText?.length > 0 &&
            nextProps?.retrieveZipCodeDetails?.error?.errorText?.[0]?.id === '17108'
          ) {
            error = {
              value: nextProps?.retrieveZipCodeDetails?.error?.value,
              errorText: ConstantText?.invalidZipError,
            };
          } else if (nextProps?.retrieveZipCodeDetails?.error?.value) {
            showErrorBanner(nextProps?.retrieveZipCodeDetails?.error);
            error = {
              value: false,
              errorText: '',
            };
          }
        } else {
          buttonEnable = true;
          showErrorBanner({});
          error = {
            value: false,
            errorText: '',
          };
        }
        continueButtonStatus(buttonEnable);
        this.setState({ inputError: error });
      }
    }
  }

  render() {
    const { handleContinueButtonClick, onChangeTextBox, onAddressSelection } = this;
    const { inputError } = this.state;
    const { addressDetails, enableContinueButton, open, closebuttonFn, updateUserTypedAddress } = this.props;
    return (
      <Grid>
        <Row className="marginTop16">
          <Col colSizes={{ mobile: 4, tablet: 12, desktop: open === 'popup' ? 12 : 5 }} className={open === 'popup' && 'noLeftPad noRightPad'}>
            <AddressField
              onChangeStreetAddress={this.onChangeStreetAddress}
              streetAddress={this.state.streetAddress}
              inputLabel={ConstantText.inputLabel}
              onAddressSelection={onAddressSelection}
              onChangeTextBox={onChangeTextBox}
              addressList={addressDetails?.suggestionList}
              typedValue={this.props?.streetAddress}
              helperText={ConstantText.helperText}
              errorState={inputError}
            />
          </Col>
        </Row>
        <Row className="marginTop24">
          {open !== 'popup' ? (
            <Col>
              <Button role="link" width={330} onClick={(e) => handleContinueButtonClick(e)} disabled={!enableContinueButton}>
                Continue
              </Button>
            </Col>
          ) : (
            <div className="width100">
              <span className="margin4">
                <Button
                  width="47%"
                  onClick={(e) => {
                    handleContinueButtonClick(e);
                  }}
                  disabled={!enableContinueButton}
                >
                  Continue
                </Button>
              </span>
              <span className={isMobile() ? ' margin4' : 'margin4'}>
                <Button
                  width="47%"
                  secondary
                  onClick={(e) => {
                    closebuttonFn(e);
                    updateUserTypedAddress('');
                  }}
                >
                  Close
                </Button>
              </span>
            </div>
          )}
        </Row>
      </Grid>
    );
  }
}
